import { render, staticRenderFns } from "./Close.vue?vue&type=template&id=40ce1b7b&scoped=true&"
var script = {}
import style0 from "./Close.vue?vue&type=style&index=0&id=40ce1b7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ce1b7b",
  null
  
)

export default component.exports